import align from "./resolvers/align/index.js";
import aspectRatio from "./resolvers/aspectRatio/index.js";
import bleed from "./resolvers/bleed/index.js";
import border, { borderColor, borderTop, borderBottom, borderStart, borderEnd, borderInline, borderBlock, } from "./resolvers/border/index.js";
import height from "./resolvers/height/index.js";
import inset, { insetTop, insetBottom, insetStart, insetEnd, insetInline, insetBlock, } from "./resolvers/inset/index.js";
import justify from "./resolvers/justify/index.js";
import maxHeight from "./resolvers/maxHeight/index.js";
import maxWidth from "./resolvers/maxWidth/index.js";
import minHeight from "./resolvers/minHeight/index.js";
import minWidth from "./resolvers/minWidth/index.js";
import position from "./resolvers/position/index.js";
import radius from "./resolvers/radius/index.js";
import textAlign from "./resolvers/textAlign/index.js";
import width from "./resolvers/width/index.js";
import padding, { paddingTop, paddingBottom, paddingStart, paddingEnd, paddingInline, paddingBlock, } from "./resolvers/padding/index.js";
const mixinMap = {
    align,
    aspectRatio,
    bleed,
    border,
    borderTop,
    borderBottom,
    borderStart,
    borderEnd,
    borderInline,
    borderBlock,
    borderColor,
    height,
    padding,
    paddingTop,
    paddingBottom,
    paddingStart,
    paddingEnd,
    paddingInline,
    paddingBlock,
    inset,
    insetTop,
    insetBottom,
    insetStart,
    insetEnd,
    insetInline,
    insetBlock,
    justify,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    position,
    radius,
    textAlign,
    width,
};
export const resolveMixin = (mixin) => {
    const output = {
        variables: {},
        classNames: [],
    };
    const entries = Object.entries(mixin);
    entries.forEach(([key, value]) => {
        const mixin = mixinMap[key];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - too complex to resolve inference without manual typing every method
        const result = mixin(value);
        if (result.variables)
            output.variables = { ...output.variables, ...result.variables };
        if (result.classNames)
            output.classNames.push(result.classNames);
    });
    return output;
};
